import React from 'react';
import { IconProps } from '../types/types';

const CVC: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1969.66 2000" role="img" {...props}><path d="M1099.37 1077.85a234.47 234.47 0 0 0 131.06-210.66c0-129.41-104.63-234.29-233.59-234.29S763.2 737.77 763.2 867.18a234.32 234.32 0 0 0 131.16 210.66v289.36h205v-289.35M996.85 1750c-412.27 0-747.63-336.42-747.63-750s335.41-749.94 747.63-749.94c336.42 0 621.58 224 715.14 531.16h257.67C1870.24 334.17 1472.44 0 996.85 0 446.31 0 0 447.71 0 1000s446.31 1000 996.85 1000c475.59 0 873.39-334.17 972.82-781.23H1712C1618.37 1526 1333.27 1750 996.85 1750" fill="#3ab03e"/></svg>
);

export default CVC;
